import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatMessage } from 'src/app/models/chatMessage';
import { MatDialog } from '@angular/material/dialog';
import { MediaPreviewComponent } from './media-preview/media-preview.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ModalComponent } from '../../modal/modal.component';
import { PipesModule } from '../../../pipes/pipes.module';
import { FileHelperService } from 'src/app/services/file-helper.service';
import { UserDataService } from 'src/app/services/userData.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChatService } from '../../../services/chat.service';
import { ApiService } from 'src/app/services/communications/api.service';
import { ImageEditorResultData } from 'src/app/interfaces/imageeditor-resultdata';
import * as constants from 'src/app/constants/constants';
import { ImageEditorComponent } from '../../image-editor/image-editor.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ChatMessageType, MediaType, ChatMessageSystem } from 'src/app/constants/constants';
import { environment } from '../../../../environment/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { SignalRService } from '../../../services/communications/signalr.service';
import { SnackBarService } from '../../../services/snackbar.service';


@Component({
  selector: 'directCall-chat-message',
  imports: [CommonModule, MatDialogModule, PipesModule, TranslateModule],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})

export class MessageComponent implements OnInit {

  @Input() chatMessage: ChatMessage = new ChatMessage(-1, '');
  @Output() messageLoaded = new EventEmitter<void>();

  currentUserId: number;
  assetId: number;
  color?: string;
  backgroundColor?: string;
  borderColor?: string;
  videoPoster: string = '';
  canDelete: boolean = false;
  isExpert: boolean;
  mediaTypeEnum = MediaType;
  chatMessageTypeEnum = ChatMessageType;
  chatMessageSystemEnum = ChatMessageSystem;
  remoteeyeUrl: string = environment.remoteeyeUrl;
  openReportTooltip: string = "TOOLTIP.OPEN_REPORT";
  sendReportByEmailTooltip: string = "TOOLTIP.SEND_REPORT_BY_EMAIL";

  loadingProgress: number = 0;
  onReceiveUploadProgress!: Subscription;


  constructor(public dialog: MatDialog, public fileHelperService: FileHelperService, public userDataService: UserDataService, private chatService: ChatService, private apiServices: ApiService, private translate: TranslateService,
    private snackBarService: SnackBarService, private signalRService: SignalRService, private sanitizer: DomSanitizer) {
    this.currentUserId = userDataService.Id!;
    this.assetId = userDataService.AssetId!;
    this.isExpert = userDataService.isExpert();
  }

  async ngOnInit() {
    this.color = this.chatMessage.color;
    this.backgroundColor = `rgba(${this.chatService.getBackgroundColor(this.chatMessage.color!)}, 0.1)`;
    this.borderColor = `1px solid ${this.chatMessage.color}`;
    this.canDelete = this.currentUserId == this.chatMessage.userId;

    if (this.chatMessage.chatFile?.mediaType == this.mediaTypeEnum.Video) await this.handleFileUploadAsync();

    this.onReceiveUploadProgress = this.signalRService.onReceiveUploadProgress.subscribe(data => {
      console.log("upload progress", data);
      if (this.chatMessage.id != data.messageId) return;
      this.loadingProgress = data.progress;
      if (this.loadingProgress == 100) setTimeout(() => this.loadingProgress = 0, 1000);
    });

  }

  ngOnDestroy() {
    this.onReceiveUploadProgress.unsubscribe();
  }

  openMediaModal(url: string, mediaType: MediaType): void {
    this.dialog.open(MediaPreviewComponent, {
      height: 'auto',
      maxHeight: '90vh',
      data: {
        url: url,
        mediaType: mediaType
      }
    });
  }

  downloadFile() {
    window.open(this.chatMessage.chatFile?.url, '_blank');
  }

  openVideoUrl() {
    const url = this.chatMessage.chatFile?.url;
    window.open(url, '_blank');
  }

  deleteMessage() {
    const deleteMessageDialog = this.dialog.open(ModalComponent, {
      autoFocus: true,
      data: {
        title: 'CHAT.DELETE_MESSAGE_TITLE',
        message: 'CHAT.MODAL_DELETE_MESSAGE_CONTENT',
        addButtons: true
      }
    });

    deleteMessageDialog.afterClosed().subscribe((result: boolean) => {
      if (result == true) {
        console.log("delete messageid:", this.chatMessage.id);
        this.apiServices.deleteMessage(this.chatMessage.id!, this.assetId).subscribe({
          next: (data) => {
            console.log("delete message sent ok");
          },
          error: (err) => {
            console.error(err);
          }
        });
      }
    });
  }

  editImage(id: number, fileName: string) {
    console.log("File to edit", id);
    this.apiServices.getBase64Image(id, this.userDataService?.assetInfo.id!).subscribe({
      next: data => {
        console.log("Receved data", data);
        let dialogEditor = this.dialog.open(ImageEditorComponent, {
          panelClass: 'edit-image-dialog',
          autoFocus: false,
          data: { img: data.base64Image, mode: constants.ImageEditorModes.Edit, isExpert: this.userDataService.isExpert, isHdImage: false, inCall: false },
        });

        dialogEditor.afterClosed().subscribe((result: ImageEditorResultData) => {
          this.processEditedImage(result, "edited_" + fileName, data.mimeType);
        });
      },
      error: err => {
        console.error("Error image to edit" + JSON.stringify(err));
      }
    });
  }

  processEditedImage(result: ImageEditorResultData, filename: string, mime: string) {
    console.log("* Process image edit response");
    console.log("Close by :" + constants.ImageEditorActions[result.action]);
    switch (result.action) {
      case constants.ImageEditorActions.saveAndClose: {
        let file = this.fileHelperService.urltoFile(result.originalImageBase64, filename, mime).then((result: File) => {
          this.chatService.imageEdited(result);
        });
        break;
      }
      default: {
        console.log('The dialog was closed, nothing to do');
        break;
      }
    }
  }

  loaded() {
    console.log("Element loaded");
    this.messageLoaded.emit();
  }

  downloadAssistanceReport() {
    this.apiServices.getAssistanceReport(this.chatMessage.assistanceId!).subscribe({
      next: htmlContent => {
        const newTab = window.open("", '_blank');
        if (newTab) {
          newTab.document.open();
          newTab.document.write(htmlContent);
          newTab.document.close();
        } else {
          this.translate.get('REPORT.DOWNLOAD_ERROR').subscribe((text: string) => {
            this.snackBarService.openError(text);
          });
        }
      },
      error: error => {
        console.log("Download report:" + error);
      }
    });
  }

  sendEmail() {
    let subject: string, startDate: string, endDate: string, summary: string, assistance: string, asset: string, comments: string, survey: string;
    subject = startDate = endDate = summary = assistance = asset = comments = survey = "";

    this.translate.get('EMAIL_ASSISTANCE_REPORT.SUBJECT').subscribe((text: string) => { subject = text; });
    this.translate.get('EMAIL_ASSISTANCE_REPORT.START_DATE').subscribe((text: string) => { startDate = text; });
    this.translate.get('EMAIL_ASSISTANCE_REPORT.END_DATE').subscribe((text: string) => { endDate = text; });
    this.translate.get('EMAIL_ASSISTANCE_REPORT.SUMMARY').subscribe((text: string) => { summary = text; });
    this.translate.get('GENERAL.ASSISTANCE').subscribe((text: string) => { assistance = text; });
    this.translate.get('GENERAL.ASSET').subscribe((text: string) => { asset = text; });
    this.translate.get('ASSISTANCES_MODAL.COMMENTS').subscribe((text: string) => { comments = text; });
    this.translate.get('EMAIL_ASSISTANCE_REPORT.SURVEY').subscribe((text: string) => { survey = text; });

    let currentAssistance = this.userDataService.assetInfo.assistances;
    let assetName = this.userDataService.assetInfo.name;

    this.apiServices.getAssistanceEmail(this.chatMessage.assistanceId!).subscribe({
      next: data => {
        var body = `${asset}: ${assetName} \n${assistance}: ${currentAssistance[0].name}\n${comments}: ${currentAssistance[0].description}\n${startDate}: ${data.StartDate} \n${endDate}: ${data.EndDate}\n\n${summary}: ${data.Summary}  \n `;
        if (data.SurveyUrl != null) body += ` \n ${survey}: ${data.SurveyUrl} \n `;

        const mailtoLink = `mailto:${this.userDataService.Name}?subject=${subject}: "${currentAssistance[0].name}"&body=${encodeURIComponent(body)}`;
        window.open(mailtoLink);
      },
      error: error => {
        console.log("Send chat message error:" + error);
      }
    });

  }

  async handleFileUploadAsync() {
    console.log("is iphone", this.isIphone());
    if (this.isIphone() && this.chatMessage.chatFile?.url != undefined) {
      await this.generateThumbnail(this.chatMessage.chatFile?.url).then((thumbnail) => {
        this.videoPoster = thumbnail;
      });;
    } else {
      this.videoPoster = '';
    }
  }

  generateThumbnail(src: SafeUrl | File): Promise<string> {
    let videoUrl: string;

    if (src instanceof File) {
      videoUrl = URL.createObjectURL(src);
    } else {
      videoUrl = src.toString();
    }

    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.src = videoUrl;
      video.crossOrigin = 'anonymous';
      video.muted = true;
      video.playsInline = true;

      video.load();

      video.onloadeddata = () => {
        video.currentTime = 0.1; // Ir a un pequeño offset para evitar un frame vacío

        video.onseeked = () => {
          console.log("Frame listo, generando imagen...");
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');

          if (!ctx) {
            reject("No se pudo obtener el contexto del canvas");
            return;
          }

          canvas.width = video.videoWidth || 320;
          canvas.height = video.videoHeight || 180;

          // Usamos requestAnimationFrame para asegurarnos de que el frame se ha pintado
          requestAnimationFrame(() => {
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            const imageUrl = canvas.toDataURL('image/png');
            resolve(imageUrl);
            video.remove();
          });
        };
      };

      video.onerror = (error) => {
        video.remove();
        console.log("error", JSON.stringify(error, null, 2));
        reject(error);
      };
    });
  }

  isIphone(): boolean {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
  }

}
